/* global console */
document.addEventListener("DOMContentLoaded", ()=> {

    let stkWhmcs;
    stkWhmcs = new StkWhmcs();

});


class StkWhmcs {

    // #saldo = 0;
    #inputSearchElement = null;
    #formCheckDomain = null;
    #query = null;
    #formData = null;
    #whmcsContainer = null;
    #preloaderImageUrl = 'https://www.ibe.pl/wp-content/plugins/stk-ibe/js/jquery/preloader.gif';
    #domainsForTesting = null;
    #apiUrl = '/wp-json/stk-whmcs/v1/dane';
    #apiCounter = 0;
    #preloaderContainer = null;
    #preloaderPercentages = null;
    #whmcsContainerInner = null;
    #offerName = null;
    constructor() {
        this.#inputSearchElement = document.getElementById('domainSearch');
        this.#formCheckDomain = document.getElementById('whmcsForm');
        this.#whmcsContainer = document.getElementById('whmcs-container-outer');
        this.#whmcsContainerInner = document.getElementById('whmcs-container-inner');
        this.addListenerSubmit();
        this.#offerName = this.#whmcsContainer.dataset.offer;

        this.#query = {
            'action': 'DomainWhois',
            'domain': null,
            'tld': null,
            'responsetype': 'json',
        }
    }

    isValidSubdomain(name){
        const regex = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/i;
        return regex.test(name);
    }
    addListenerSubmit(){
        this.#formCheckDomain.addEventListener('submit',(e) => {
            e.preventDefault();
            this.#query.domain = this.#inputSearchElement.value;

            if (this.#inputSearchElement.value === "") {
                alert('Wpisz nazwę domeny');
                return;
            }

            if(!this.isValidSubdomain(this.#inputSearchElement.value)){
                alert('Zła nazwa domeny, dopuszcza litery, cyfry, myślniki, maksymalnie 63 znaki');
                return;
            }

            this.#formData = new FormData(this.#formCheckDomain);

            const popular = this.#formData.getAll('whmcsTldPopular[]');
            const functional = this.#formData.getAll('whmcsTldFunctional[]');
            const regional = this.#formData.getAll('whmcsTldRegional[]');

            this.#domainsForTesting = [...popular, ...functional, ...regional];

            if(this.#domainsForTesting.length < 1){
                alert('Wybierz domenę główną');
                return;
            }

            this.showPreloader();
            this.#whmcsContainerInner.innerHTML = "";
            this.showHeadeLabel();

            this.#domainsForTesting.forEach((item, index)=>{

                if(index==0){
                    this.showHeadeResult();
                }

                this.#query.tld = item;

                fetch( this.#apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify( this.#query )
                    // body: JSON.stringify(jsonData)
                })
                    .then( response => response.json() )
                    .then( (data) => {
                        this.addToResultContainer(data);
                    })
                    .catch(error => {
                        console.error('Wystąpił błąd:', error);
                    })
                    .finally(() => {
                        this.#apiCounter++;
                        this.updatePreloader();
                        if(this.#apiCounter>=this.#domainsForTesting.length){
                            this.hidePreloader();
                            this.showFooterLabel();
                        }
                    });

            });

        });
    }

    showPreloader() {
        const div = document.createElement("div");
        div.classList.add("whmcs__preloader");
        div.id = "whmcs-preloader";

        const img = document.createElement("img");
        img.src = this.#preloaderImageUrl;
        img.alt = "preload";
        img.classList.add("whmcs__preloader-image");
        div.appendChild(img);

        const percentages = document.createElement("div");
        percentages.classList.add("whmcs__preloader-percentages");
        percentages.id = "whmcs-preloader-percentages";
        percentages.textContent = "0%";
        this.#preloaderPercentages = div.appendChild(percentages);

        this.#preloaderContainer = this.#whmcsContainer.appendChild(div);
    }

    hidePreloader(){
        this.#preloaderContainer.remove();
        this.#apiCounter = 0;
    }

    updatePreloader(){
        this.#preloaderPercentages.textContent = `${Math.round(this.#apiCounter/this.#domainsForTesting.length*100)}%`;
    }

    addToResultContainer(data){
        const obiekt = JSON.parse(data.data);
        const div = document.createElement("div");
        div.classList.add("whmcs__result-item");
        div.classList.add(obiekt.status);

        const cartUrl = `https://billing.ibe.pl/cart.php?a=add&domain=register&domains[]=${data.domain}.${data.tld}&domainsregperiod[${data.domain}.${data.tld}]=1`;

        div.innerHTML = (obiekt.status=='available')
            ? `<div>${data.domain}.${data.tld}</div><div class="${obiekt.status}">${obiekt.status}</div><div>${data.register}</div><div>${data.renew}</div><div>${this.#offerName}</div><div><a class="stk-ibe-add-to-basket" href="${cartUrl}"><i class="fa fa-shopping-cart" aria-hidden="true"></i> do koszyka</a></div>`
            : `<div>${data.domain}.${data.tld}</div><div class="${obiekt.status}">${obiekt.status}</div>`;


        this.#whmcsContainerInner.appendChild(div);
        // https://billing.ibe.pl/cart.php?a=add&domain=register&domains[]=sdfsd32.pl&domainsregperiod[sdfsd32.pl]=1
        // https://billing.ibe.pl/cart.php?a=add&domain=register&query=eeeeeeeeeee%20eeeee4444444444.pl
    }

    showHeadeLabel() {
        const div = document.createElement("div");
        div.classList.add("whmcs__result-label");
        div.innerHTML = '<div>Informacje na temat szukanej domeny</div>';
        this.#whmcsContainerInner.appendChild(div);
    }

    showHeadeResult() {
        const div = document.createElement("div");
        div.classList.add("whmcs__result-header");
        div.innerHTML = '<div>Domena</div><div>Status</div><div>Cena</div><div>Odnowienie</div><div>Promocja</div><div></div>';
        this.#whmcsContainerInner.appendChild(div);
    }

    showFooterLabel() {
        const div = document.createElement("div");
        div.classList.add("whmcs__result-footer");
        div.innerHTML = '<div>Ceny netto, nie zawierają podatku VAT i dotyczą kosztu rejestracji domeny na okres jednego roku.</div>';
        this.#whmcsContainerInner.appendChild(div);
    }

}
